import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  connect() {
    // Auto-show and auto-dismiss
    this.show()
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 5000) // 5 seconds
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  show() {
    // Slide in from right using inline styles
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.style.transform = "translateX(0)"
        this.element.style.opacity = "1"
      })
    })
  }

  dismiss() {
    // Slide out to right using inline styles
    this.element.style.transform = "translateX(120%)"
    this.element.style.opacity = "0"

    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  // Allow manual dismiss by clicking
  close(event) {
    event.preventDefault()
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.dismiss()
  }
}
